import { LegalLayout } from "../components/LegalLayout";
import { Seo } from "../components/Seo";

const H2 = ({ children }) => (
  <h2 className="font-heading text-2xl md:text-3xl font-bold uppercase tracking-tight text-white mt-12 mb-4">
    {children}
  </h2>
);

export default function MentionsLegales() {
  return (
    <>
      <Seo
        title="Mentions légales — PDR France"
        description="Mentions légales de PDR France (SARL PDR France, EURL) — SIREN 944 868 678, siège social à Saint-Étienne."
        path="/mentions-legales"
      />
      <LegalLayout
      title="Mentions légales"
      eyebrow="Informations légales"
      lastUpdate="Décembre 2025"
    >
      <p>
        Conformément aux dispositions des articles 6-III et 19 de la loi
        n°2004-575 du 21 juin 2004 pour la Confiance dans l'économie
        numérique (LCEN), il est porté à la connaissance des utilisateurs
        du site les présentes mentions légales.
      </p>

      <H2>1. Éditeur du site</H2>
      <ul className="space-y-2 list-none pl-0">
        <li><strong className="text-white">Raison sociale :</strong> PDR FRANCE</li>
        <li><strong className="text-white">Nom commercial :</strong> SARL PDR France</li>
        <li><strong className="text-white">Forme juridique :</strong> EURL — Entreprise unipersonnelle à responsabilité limitée</li>
        <li><strong className="text-white">Capital social :</strong> 500,00 €</li>
        <li>
          <strong className="text-white">Siège social :</strong> Chez M. EL OUAZZANI Youssef, 1305 route de Faverange, 42230 Saint-Étienne, France
        </li>
        <li><strong className="text-white">Date de création :</strong> 02/06/2025</li>
        <li><strong className="text-white">SIREN :</strong> 944 868 678</li>
        <li><strong className="text-white">SIRET (siège) :</strong> 944 868 678 00011</li>
        <li><strong className="text-white">RCS :</strong> 944 868 678 R.C.S. Saint-Étienne (inscription au greffe le 02/06/2025)</li>
        <li><strong className="text-white">Inscription au RNE :</strong> Inscrit</li>
        <li><strong className="text-white">N° TVA intracommunautaire :</strong> FR72 944 868 678</li>
        <li>
          <strong className="text-white">Téléphone :</strong>{" "}
          <a href="tel:+33773119016" className="text-[#007AFF] hover:underline">
            07 73 11 90 16
          </a>
        </li>
        <li>
          <strong className="text-white">Email :</strong>{" "}
          <a href="mailto:debosselage@pdrfrance.fr" className="text-[#007AFF] hover:underline">
            debosselage@pdrfrance.fr
          </a>
        </li>
      </ul>

      <H2>2. Directeur de la publication</H2>
      <p>
        Le directeur de la publication est M. EL OUAZZANI Youssef, en sa
        qualité de gérant de l'EURL PDR FRANCE.
      </p>

      <H2>3. Hébergeur du site</H2>
      <ul className="space-y-2 list-none pl-0">
        <li><strong className="text-white">Hébergeur :</strong> Emergent Labs</li>
        <li>
          <strong className="text-white">Site web :</strong>{" "}
          <a
            href="https://emergent.sh"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#007AFF] hover:underline"
          >
            https://emergent.sh
          </a>
        </li>
        <li>
          <strong className="text-white">Contact :</strong>{" "}
          <a href="mailto:support@emergent.sh" className="text-[#007AFF] hover:underline">
            support@emergent.sh
          </a>
        </li>
      </ul>

      <H2>4. Propriété intellectuelle</H2>
      <p>
        L'ensemble des contenus présents sur le site pdrfrance.fr
        (textes, images, vidéos, logos, icônes, sons, logiciels, mise en
        page, charte graphique) est la propriété exclusive de PDR FRANCE
        ou de ses partenaires. Toute reproduction, représentation,
        modification, publication, adaptation, totale ou partielle, quel
        que soit le moyen ou le procédé utilisé, est interdite sans
        l'autorisation écrite préalable de PDR FRANCE, sous peine de
        poursuites prévues notamment par les articles L.335-2 et suivants
        du Code de la propriété intellectuelle.
      </p>

      <H2>5. Responsabilité</H2>
      <p>
        PDR FRANCE s'efforce de fournir sur le site des informations aussi
        précises que possible. Toutefois, elle ne saurait être tenue
        responsable des omissions, des inexactitudes et des carences dans
        la mise à jour, qu'elles soient de son fait ou du fait des tiers
        partenaires qui lui fournissent ces informations.
      </p>
      <p>
        L'utilisateur reconnaît utiliser ces informations sous sa
        responsabilité exclusive. PDR FRANCE ne saurait être tenue pour
        responsable en cas de dysfonctionnement du réseau Internet ou des
        serveurs.
      </p>

      <H2>6. Liens hypertextes</H2>
      <p>
        Le site peut contenir des liens hypertextes vers d'autres sites.
        PDR FRANCE n'exerce aucun contrôle sur ces sites et décline toute
        responsabilité quant à leur contenu.
      </p>

      <H2>7. Droit applicable</H2>
      <p>
        Les présentes mentions légales sont régies par la loi française.
        En cas de litige, et après échec de toute tentative de résolution
        amiable, les tribunaux de Saint-Étienne seront seuls compétents.
      </p>

      <H2>8. Contact</H2>
      <p>
        Pour toute question relative aux présentes mentions légales, vous
        pouvez nous contacter par email à l'adresse :{" "}
        <a href="mailto:debosselage@pdrfrance.fr" className="text-[#007AFF] hover:underline">
          debosselage@pdrfrance.fr
        </a>
      </p>
    </LegalLayout>
    </>
  );
}
